import { Entity, Key } from '@briebug/ngrx-auto-entity';
import { Role } from '../role/role.model';
import { Fournisseur } from '../fournisseur/fournisseur.model';
import { Groupe } from '../groupe/groupe.model';

@Entity({ modelName: 'User' })
export class User {
    @Key id: number;
    username: string;
    password: string;
    name: string;
    enabled: boolean;
    role: Role;
    groupes: Groupe[];
    email: string;
    fournisseurs: Fournisseur[] = [];


    constructor() {
        this.groupes = [];
        this.enabled = true;
    }

}